import styled from "styled-components";

import Card from '../components/Card';

const Pool = ({}) => {
    return (
        <>
            <Card />
        </>
    );
}

export default Pool;